<template>
  <div class="overlay">
    <div class="modal">
      <!-- <over-loading v-if="loading" class="loading" /> -->
      <div>
        <h1 class="title">{{ lang.selectCountry }}</h1>
        <div>
          <SelectCountry
            :countryName="countryName"
            :countries="countries"
            :lang="lang"
            @changeCountry="$emit('changeCountry', $event)"
          />
        </div>
      </div>
      <button
        :disabled="!countryName"
        class="submit-btn"
        type="button"
        @click="setCountry()"
      >
        {{ lang.next }}
      </button>
    </div>
  </div>
</template>

<script>
import SelectCountry from "@/components/Panel/Profile/SelectCountry.vue";
// import overLoading from "@/components/tools/over-loading.vue";

export default {
  name: "SelectCountryModal",
  props: ["lang", "countryName", "countries"],
  components: {
    SelectCountry,
    // overLoading
  },
  computed: {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async setCountry() {
      this.loading = true;
      this.state.loading = true;
      try {
        await this.$axios.post("/users/set-country", {
          countryName: this.countryName,
        });
        this.state.loading = false;
        this.$emit("select");
      } catch (error) {
        this.state.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.overlay {
  position: fixed;
  right: 0;
  top: 0;
  left: 44px;
  bottom: 0;
  white-space: nowrap;
  z-index: 10000000;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.8s;
  overflow-y: hidden;
  padding: 16px;
}
[dir="rtl"] .overlay {
  left: 0;
  right: 44px;
}
.modal {
  background-color: #030920;
  border-radius: 3px;
  max-width: 380px;
  width: 100%;
  height: 410px;
  padding: 24px;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h1 {
    margin-top: 0;
  }
}
.title {
  color: #fff;
  font-size: 18px;
  text-align: center;
}
.submit-btn {
  background: linear-gradient(
    90deg,
    #1a97bf 2.72%,
    #721ac9 28.48%,
    #ab0ae3 62.88%,
    #c102c5 78.84%,
    #bb1396 100%
  );
  border-radius: 8px;
  height: 35px;
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  color: #fcfcfc;
  font-size: clamp(14px, 1.5vw, 16px);
}
</style>
